import React from 'react';

import {VALIDATION_FAILED_MESSAGE} from 'samples/plate-maps/transfer-table/validation/FillPlateTransferTableValidationConstants';
import InlineBanner, {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';
import {AsyncStatus} from 'ui-library/hooks/useAsyncState';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

/**
 * Loading state for steps that require a plate map before said plate map is generated, or while said plate
 * map is being validated.
 *
 * @param refetch A function to re-request plate map validation.
 * @param validationStatus The status of the validation request.
 * @param validationRequestFailedMessage A friendly message (i.e. from notifications.getFriendlyError)
 *        describing the error in the validation request, if the validation status is ERROR
 */
export function NoPlateMap({
  refetch,
  validationStatus,
  validationRequestFailedMessage,
}: {
  refetch: null | (() => void);
  validationStatus: AsyncStatus;
  validationRequestFailedMessage: string | null;
}): JSX.Element | null {
  if (validationStatus === AsyncStatus.SUCCESS) {
    return null;
  }

  return (
    <>
      {validationStatus === AsyncStatus.NOT_FETCHED || validationStatus === AsyncStatus.LOADING ? (
        <CenteredHorizontalThrobber />
      ) : (
        <InlineBanner
          bannerType={InlineBannerType.ERROR}
          text={VALIDATION_FAILED_MESSAGE}
          supportingInfo={validationRequestFailedMessage ?? ''}
          {...(refetch != null
            ? {
                action: {
                  actionType: InlineBannerActionType.CUSTOM,
                  actionText: 'Retry?',
                  actionOnClick: refetch,
                },
              }
            : {})}
        />
      )}
    </>
  );
}
